import { useRouter } from 'next/router';
import PropTypes from 'prop-types';

import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { Flex } from '@components/grid';
import { analytics } from '../../../analytics';
import { NavItem } from './nav-item';
import { P } from '../../typography/new';
import { useAccountNavigationItems } from '../../../hooks/use-account-navigation-items';

const AccountNav = ({ handleSignOut, routes, ...rest }) => {
  const router = useRouter();
  const defaultRoutes = useAccountNavigationItems();
  const displayRoutes = routes || defaultRoutes;
  return (
    <Flex flexDirection="column" mt="72px" {...rest}>
      {displayRoutes.map(({ label, href, target, badge }) => (
        <NavItem
          active={router ? href === router.pathname : false}
          onClick={() =>
            analytics.track(ANALYTICS_EVENTS.ACCOUNT_NAV_CLICKED, {
              text: label,
            })
          }
          href={href}
          key={label}
          label={label}
          target={target}
          badge={badge}
        />
      ))}

      {handleSignOut && (
        <Flex
          as="button"
          onClick={() => {
            analytics.track(ANALYTICS_EVENTS.ACCOUNT_NAV_CLICKED, {
              text: 'Sign Out',
            });

            handleSignOut();
          }}
          py="24px"
          px="20px"
        >
          <P variant="standard">Sign Out</P>
        </Flex>
      )}
    </Flex>
  );
};

AccountNav.propTypes = {
  handleSignOut: PropTypes.func,
  routes: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      badge: PropTypes.number,
    })
  ),
};

AccountNav.defaultProps = {
  handleSignOut: null,
  routes: undefined,
};

export { AccountNav };
